import PropTypes from 'prop-types';

import { MEDIA_TYPES } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const LinksDefaultProps = {
  ...ClassNameDefaultProps,
  handleClickitem: () => null,
  hasPrint: true,
  links: null,
  slider: [],
  video: null,
};

export const LinksPropTypes = {
  ...ClassNamePropTypes,
  handleClickItem: PropTypes.func,
  hasPrint: PropTypes.bool,
  links: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  slider: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      path: PropTypes.string,
      type: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]),
      url: PropTypes.string,
    }),
  ),
  video: PropTypes.shape({
    alt: PropTypes.string,
    code: PropTypes.string,
    label: PropTypes.string,
    legend: PropTypes.string,
    path: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
  }),
};
